/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface RuleScriptEntity
 */
export interface RuleScriptEntity {
    /**
     * 
     * @type {number}
     * @memberof RuleScriptEntity
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof RuleScriptEntity
     */
    content?: string;
    /**
     * 
     * @type {Date}
     * @memberof RuleScriptEntity
     */
    dateCreated?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof RuleScriptEntity
     */
    isDraft?: boolean;
}

/**
 * Check if a given object implements the RuleScriptEntity interface.
 */
export function instanceOfRuleScriptEntity(value: object): boolean {
    return true;
}

export function RuleScriptEntityFromJSON(json: any): RuleScriptEntity {
    return RuleScriptEntityFromJSONTyped(json, false);
}

export function RuleScriptEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuleScriptEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'content': json['content'] == null ? undefined : json['content'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'isDraft': json['isDraft'] == null ? undefined : json['isDraft'],
    };
}

export function RuleScriptEntityToJSON(value?: RuleScriptEntity | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'content': value['content'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'isDraft': value['isDraft'],
    };
}

